<div *ngFor="let s of case.reviewSteps; let index=index" [title]="s.longName" [ngSwitch]="stepKind(s)">

	<!-- PRC: the step label deep-links to the committees page; pencil edits reviewers inline -->
	<ng-container *ngSwitchCase="'prc'">
		{{index+1}}.&nbsp;<a
			[routerLink]="['/ahr/committees']"
			[queryParams]="{year: case.yearId - 1, tab: 'prc'}"
			[fragment]="'candidate-' + case.userId"
			target="_blank">{{ stepLabel(s.shortName, reviewers(s.id).length) }}</a>:
		<ng-container *ngFor="let r of reviewers(s.id); let i=index"><span *ngIf="i > 0">,&nbsp;</span><span
				[class.font-weight-bold]="r.writesReview">{{r.userName}}</span><ng-container *ngIf="editingPrc">
				<a href="javascript:void(0)" *ngIf="!r.writesReview" title="Make this reviewer the writer"
					(click)="makePrcWriter(r)"><i class="fa fa-pencil"></i></a>
				<a href="javascript:void(0)" class="text-danger" title="Remove reviewer"
					(click)="removePrcReviewer(r)"><i class="fa fa-times"></i></a>
			</ng-container>
		</ng-container>
		<a href="javascript:void(0)" *ngIf="editable && !editingPrc" class="ml-1 text-muted"
			title="Edit PRC reviewers" (click)="editingPrc = true"><i class="fa fa-pencil"></i></a>
		<ng-container *ngIf="editingPrc">
			<a href="javascript:void(0)" class="ml-2" title="Add reviewer" (click)="addPrcReviewer(s)"><i class="fa fa-plus"></i>&nbsp;Add</a>
			<a href="javascript:void(0)" class="ml-2" (click)="editingPrc = false">Done</a>
		</ng-container>
	</ng-container>

	<!-- Ad Hoc: the step label deep-links to the committees page; chair renders bold -->
	<ng-container *ngSwitchCase="'adhoc'">
		<ng-container *ngIf="adHocView; else legacyStep">
			{{index+1}}.&nbsp;<a
				[routerLink]="['/ahr/committees']"
				[queryParams]="{year: case.yearId - 1, tab: 'adhoc'}"
				[fragment]="adHocCommittee ? 'committee-' + adHocCommittee.committeeId : null"
				target="_blank">{{ stepLabel(s.shortName, reviewers(s.id).length) }}</a>:
			<ng-container *ngIf="adHocCommittee as c; else adHocUnassigned">
				Committee {{c.committeeId}}<span *ngIf="!adHocChair(c)" class="text-muted">&nbsp;(no chair)</span>:<ng-container
					*ngFor="let m of c.members; let i=index"><span *ngIf="i > 0">,</span>&nbsp;<span
					[class.font-weight-bold]="m.writesReview">{{m.name}}</span></ng-container>
			</ng-container>
			<ng-template #adHocUnassigned><span class="text-muted">unassigned</span></ng-template>
			<a href="javascript:void(0)" *ngIf="editable && !editingAdHoc" class="ml-1 text-muted"
				title="Assign ad hoc committee" (click)="editingAdHoc = true"><i class="fa fa-pencil"></i></a>
			<ng-container *ngIf="editingAdHoc">
				<select #adHocSel class="custom-select custom-select-sm d-inline-block ml-1" style="width: auto;"
					(change)="onAdHocSelect(adHocSel)">
					<option value="">Choose a committee…</option>
					<option *ngFor="let c of adHocView.committees" [value]="c.committeeId">{{ adHocCommitteeLabel(c) }}</option>
					<option value="new">New committee…</option>
					<option value="unassign" *ngIf="adHocCommittee">Unassign</option>
				</select>
				<a href="javascript:void(0)" class="ml-2" (click)="editingAdHoc = false">Done</a>
			</ng-container>
		</ng-container>
	</ng-container>

	<!-- All other steps: unchanged read-only rendering -->
	<ng-container *ngSwitchDefault>
		<ng-container *ngTemplateOutlet="legacyStep"></ng-container>
	</ng-container>

	<ng-template #legacyStep>
		{{index+1}}.&nbsp;{{ stepLabel(s.shortName, reviewers(s.id).length) }}<span *ngIf="case.reviewersByStepId.has(s.id)">:
			<ng-container *ngFor="let r of reviewers(s.id); let i=index"><span *ngIf="i > 0">,&nbsp;</span><span [class.font-weight-bold]="r.writesReview">{{r.userName}}</span></ng-container>
		</span>
	</ng-template>
</div>
